import styled from "styled-components"

function SubTypeFilter() {
    return(SubType)
}

const SubType = [
["Arma", ""],
["Espada 1 Mão","1hSword"],
["Espada 2 Mãos","2hSword"],
["Adaga","Dagger"],
["Katar","Katar"],
["Machado 1 Mão","1hAxe"],
["Machado 2 Mãos","2hAxe"],
["Shuriken Huuma","Huuma"],
["Maça","Mace"],
["Lança 1 Mão","1hSpear"],
["Lança 2 Mãos","2hSpear"],
["Cajado","Staff"],
["Cajado 2 Mãos","2hStaff"],
["Livro","Book"],
["Arco","Bow"],
["Flecha","Arrow"],
["Soqueira","Knuckle"],
["Instrumento","Musical"],
["Chicote","Whip"],
["Encantamento","Enchant"],
["Revolve","Revolve"],
["Rifle","Rifle"],
["Escopeta","Shotgun"],
["Metralhadora","Gatling"],
["Granada","Grenade"],
["Munição","Bullet"],
["Shuriken","Shurike"],
["Kunai","Kunai"],
["Arremesso","Throwwe"],
["Bala de Canhão","Cannonb"]
]


export default SubTypeFilter;